import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectApplicationQrveyInStore,
  selectApplicationQrveyPageLoading,
  selectApplicationQrveyShowInitWaitingMessage,
} from '../_selectors/application-qrvey.selectors';

export class ApplicationsQrveyDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectApplicationQrveyPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectApplicationQrveyShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectApplicationQrveyInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
